/* NC · Cart Trust — variante A, déploiement permanent (hors logique Shoplift) */
(function () {
  var cfg = (window.NC || {}).cartTrust;
  if (!cfg) return;

  var ICONS = {
    lock: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>'
  };

  var s = cfg.strings || {}, pay = cfg.paymentsHtml || '';

  // Masquage du sous-total (ex-variante A) — posé une fois, sans attendre le cart.
  document.documentElement.classList.add('nc-hide-subtotal');

  function html(){
    var payRow = pay ? '<div class="nc-cart-trust__payments">' + pay + '</div>' : '';
    var line = '<p class="nc-cart-trust__line">' + ICONS.lock +
      '<span>' + s.secure + '</span><span class="nc-cart-trust__sep">|</span>' +
      '<span>' + s.returns + '</span><span class="nc-cart-trust__sep">|</span>' +
      '<span>' + s.delivery + '</span></p>';
    return '<div class="nc-cart-trust nc-cart-trust--a" data-nc-cart-trust>' + payRow + line + '</div>';
  }

  function btnNow(){
    var b = document.querySelector('.candyrack-slider-cart-footer-checkout-button')
         || document.querySelector('.candyrack-slider-cart-footer-wrapper button[name="checkout"]');
    return (b && (b.offsetWidth || b.offsetHeight || b.getClientRects().length)) ? b : null;
  }

  function place(btn){
    var footer = btn.closest('.candyrack-slider-cart-footer-wrapper') || btn.parentNode;
    if (footer.querySelector('[data-nc-cart-trust]')) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html();
    var bw = btn.closest('.candyrack-slider-cart-footer-buttons-wrapper') || btn.parentNode;
    bw.parentNode.insertBefore(tmp.firstElementChild, bw.nextSibling);
  }

  function onChange(){
    var btn = btnNow();
    if (btn) place(btn);
  }

  new MutationObserver(onChange).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', onChange);
  onChange();
})();
